/**
 * FAQ Table of Contents Component
 * Handles navigation and active state for FAQ categories
 */
if (!window.customElements.get("faq-toc")) {
  class FaqToc extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const links = this.querySelectorAll("a.faq__toc-item");

      links.forEach((link) => {
        link.addEventListener("click", (e) => {
          e.preventDefault();
          const targetId = link.getAttribute("href").replace("#", "");
          const targetElement = document.getElementById(targetId);

          if (targetElement) {
            // Update active state
            links.forEach((l) => l.classList.remove("is-active"));
            link.classList.add("is-active");

            // Scroll to target
            targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        });
      });

      // Update active state on scroll
      this.setupScrollObserver(links);
    }

    setupScrollObserver(links) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const id = entry.target.id;
              links.forEach((link) => {
                if (link.getAttribute("href") === `#${id}`) {
                  links.forEach((l) => l.classList.remove("is-active"));
                  link.classList.add("is-active");
                }
              });
            }
          });
        },
        { rootMargin: "-20% 0px -70% 0px" }
      );

      // Observe all FAQ category blocks
      links.forEach((link) => {
        const targetId = link.getAttribute("href").replace("#", "");
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          observer.observe(targetElement);
        }
      });
    }
  }

  window.customElements.define("faq-toc", FaqToc);
}

